import { useEffect, useState } from "react";
import Search from "../../components/UserDashboard/Search";
import "../../styles/UserDashboard/NdcList.scss";
import { MenuItem, Select } from "@mui/material";
import moment from "moment";
import { getNdcValue } from "../../apis/General/users";
import { useSelector } from "react-redux";
import SideBar from "../../components/UserDashboard/SideBar";
import { useNavigate } from "react-router-dom";
import { countries } from "../../data/countries";

export default function NdcList() {
  const navigate = useNavigate();

  const auth = useSelector((state) => state.auth);
  const [dateRange, setDataRange] = useState("Country");
  const [countryModal, setCountryModal] = useState(false);
  const [ndcCalendar, setNdcCalendar] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [bookedDates, setBookedDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [firstDate, setFirstDate] = useState(null);
  const [lastDate, setLastDate] = useState(null);
  const [facilities, setFacilities] = useState([]);
  const [filteredFacilities, setFilteredFacilities] = useState([]);
  const [rangeLoading, setRangeLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [filteredCountries, setFilteredCountries] = useState(countries);
  const [text, setText] = useState("");

  useEffect(() => {
    const temp = countries?.filter((country) =>
      country?.label?.toLowerCase()?.includes(text?.toLowerCase())
    );
    setFilteredCountries(temp);
  }, [text]);

  useEffect(() => {
    console.log('selectedCountry', selectedCountry);
    if (selectedCountry?.length > 0) {
      const temp = facilities.filter(
        (facility) => facility?.country === selectedCountry
      );
      console.log('tempop', temp);
      setFilteredFacilities(temp);
    }else {
      setFilteredFacilities(facilities);
    }
  }, [selectedCountry]);

  const handleIncrementMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleDecrementMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const renderCalendarGrid = () => {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const startDay = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    const rows = [];
    let currentDay = 1;

    console.log("perimiter", new Date().getMonth());
    console.log("perimiter", new Date().getFullYear());

    // Create the calendar grid
    for (let i = 0; i < 6; i++) {
      const days = [];

      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < startDay) {
          // Render empty cells for days before the first of the month
          days.push(<div key={`empty-${j}`} className="calendar-cell"></div>);
        } else if (currentDay > daysInMonth) {
          // Finish rendering the calendar grid
          break;
        } else {
          // Render the date cell
          const dateString = `${currentYear}-${String(
            currentMonth + 1
          ).padStart(2, "0")}-${String(currentDay).padStart(2, "0")}`;
          const cellClassName = `calendar-cell ndc-calendar-date`;

          days.push(
            <div
              key={dateString}
              className={
                firstDate === dateString
                  ? `active-date ${cellClassName}`
                  : lastDate === dateString
                  ? `active-date ${cellClassName}`
                  : parseInt(firstDate?.split("-")[2]) <
                      parseInt(dateString?.split("-")[2]) &&
                    parseInt(lastDate?.split("-")[2]) >
                      parseInt(dateString?.split("-")[2])
                  ? `subsidiary-date ${cellClassName}`
                  : cellClassName
              }
              onClick={() => handleDateClick(dateString)}
            >
              {currentDay}
            </div>
          );
          currentDay++;
        }
      }

      rows.push(
        <div key={`row-${i}`} className="ndc-calendar-row">
          {days}
        </div>
      );
    }

    return (
      <div className="calendar-grid">
        <div className="ndc-calendar-row calendar-header">
          {daysOfWeek.map((day, index) => (
            <div key={`header-${index}`} className="calendar-cell">
              {day}
            </div>
          ))}
        </div>
        {rows}
      </div>
    );
  };

  const handleDateClick = (date) => {
    if (!firstDate) {
      setFirstDate(date);
    } else if (firstDate && !lastDate) {
      if (parseInt(firstDate?.split("-")[2]) > parseInt(date?.split("-")[2])) {
        setLastDate(firstDate);
        setFirstDate(date);
      } else {
        setLastDate(date);
      }
    } else if (!!firstDate && !!lastDate) {
      setFirstDate(date);
      setLastDate(null);
    }
  };

  const handleNdcCalendarClick = () => {
    setCountryModal(false);
    setNdcCalendar(!ndcCalendar);
  };
  const handleCountryModalClick = () => {
    setCountryModal(!countryModal);
    setNdcCalendar(false);
  };

  const clearDateSelection = () => {
    setFirstDate(null);
    setLastDate(null);
  };

  const handleGetNdc = async () => {
    setRangeLoading(true);
    // if (auth?.userInfo?.ndcValueAccess !== "approved") {
    //   // navigate("/ndc");
    // } else {
      const firstDatetemp = new Date(firstDate);
      const firstDateEpoch = firstDatetemp.getTime();

      const lastDatetemp = new Date(lastDate);
      const lastDateEpoch = lastDatetemp.getTime();

      console.log(
        "firstDateEpoch",
        firstDateEpoch,
        "lastDateEpoch",
        lastDateEpoch
      );

      const response = await getNdcValue(
        auth?.token,
        firstDateEpoch?.toString(),
        lastDateEpoch?.toString()
      );
      console.log(
        "response ndc yo",
        response,
        "first",
        firstDateEpoch?.toString(),
        "last",
        lastDateEpoch?.toString()
      );

      setFacilities(response?.data?.message);
      setFilteredFacilities(response?.data?.message);
      setNdcCalendar(false);
    // }
    setRangeLoading(false);
  };

  useEffect(() => {
    handleGetNdc();
  }, []);

  return (
    <div className="ndclist">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="ndclist_main">
        <Search />

        <div className="ndclist_title">NDCs-S</div>
        <div className="ndclist-table">
          <div className="ndclist-table__header">
            <div>NDCs-S Value</div>
            <div>
              <div
                className="ndclist-table__header__select pointer"
                onClick={handleNdcCalendarClick}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.60039 8.4C5.81256 8.4 6.01605 8.31571 6.16608 8.16569C6.31611 8.01566 6.40039 7.81217 6.40039 7.6C6.40039 7.38783 6.31611 7.18434 6.16608 7.03432C6.01605 6.88429 5.81256 6.8 5.60039 6.8C5.38822 6.8 5.18473 6.88429 5.03471 7.03432C4.88468 7.18434 4.80039 7.38783 4.80039 7.6C4.80039 7.81217 4.88468 8.01566 5.03471 8.16569C5.18473 8.31571 5.38822 8.4 5.60039 8.4ZM6.40039 10C6.40039 10.2122 6.31611 10.4157 6.16608 10.5657C6.01605 10.7157 5.81256 10.8 5.60039 10.8C5.38822 10.8 5.18473 10.7157 5.03471 10.5657C4.88468 10.4157 4.80039 10.2122 4.80039 10C4.80039 9.78783 4.88468 9.58434 5.03471 9.43432C5.18473 9.28429 5.38822 9.2 5.60039 9.2C5.81256 9.2 6.01605 9.28429 6.16608 9.43432C6.31611 9.58434 6.40039 9.78783 6.40039 10ZM8.00039 8.4C8.21256 8.4 8.41605 8.31571 8.56608 8.16569C8.71611 8.01566 8.80039 7.81217 8.80039 7.6C8.80039 7.38783 8.71611 7.18434 8.56608 7.03432C8.41605 6.88429 8.21256 6.8 8.00039 6.8C7.78822 6.8 7.58473 6.88429 7.43471 7.03432C7.28468 7.18434 7.20039 7.38783 7.20039 7.6C7.20039 7.81217 7.28468 8.01566 7.43471 8.16569C7.58473 8.31571 7.78822 8.4 8.00039 8.4ZM8.80039 10C8.80039 10.2122 8.71611 10.4157 8.56608 10.5657C8.41605 10.7157 8.21256 10.8 8.00039 10.8C7.78822 10.8 7.58473 10.7157 7.43471 10.5657C7.28468 10.4157 7.20039 10.2122 7.20039 10C7.20039 9.78783 7.28468 9.58434 7.43471 9.43432C7.58473 9.28429 7.78822 9.2 8.00039 9.2C8.21256 9.2 8.41605 9.28429 8.56608 9.43432C8.71611 9.58434 8.80039 9.78783 8.80039 10ZM10.4004 8.4C10.6126 8.4 10.816 8.31571 10.9661 8.16569C11.1161 8.01566 11.2004 7.81217 11.2004 7.6C11.2004 7.38783 11.1161 7.18434 10.9661 7.03432C10.816 6.88429 10.6126 6.8 10.4004 6.8C10.1882 6.8 9.98474 6.88429 9.83471 7.03432C9.68468 7.18434 9.60039 7.38783 9.60039 7.6C9.60039 7.81217 9.68468 8.01566 9.83471 8.16569C9.98474 8.31571 10.1882 8.4 10.4004 8.4ZM13.6004 4C13.6004 3.46957 13.3897 2.96086 13.0146 2.58579C12.6395 2.21071 12.1308 2 11.6004 2H4.40039C3.86996 2 3.36125 2.21071 2.98618 2.58579C2.6111 2.96086 2.40039 3.46957 2.40039 4V11.2C2.40039 11.7304 2.6111 12.2391 2.98618 12.6142C3.36125 12.9893 3.86996 13.2 4.40039 13.2H11.6004C12.1308 13.2 12.6395 12.9893 13.0146 12.6142C13.3897 12.2391 13.6004 11.7304 13.6004 11.2V4ZM3.20039 5.2H12.8004V11.2C12.8004 11.5183 12.674 11.8235 12.4489 12.0485C12.2239 12.2736 11.9187 12.4 11.6004 12.4H4.40039C4.08213 12.4 3.77691 12.2736 3.55186 12.0485C3.32682 11.8235 3.20039 11.5183 3.20039 11.2V5.2ZM4.40039 2.8H11.6004C11.9187 2.8 12.2239 2.92643 12.4489 3.15147C12.674 3.37652 12.8004 3.68174 12.8004 4V4.4H3.20039V4C3.20039 3.68174 3.32682 3.37652 3.55186 3.15147C3.77691 2.92643 4.08213 2.8 4.40039 2.8Z"
                    fill="#747474"
                  />
                </svg>

                <div>
                  {firstDate} - {lastDate}
                </div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.66732 6.66667L8.00065 10L11.334 6.66667"
                    stroke="#747474"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                className="ndclist-table__header__select pointer"
                onClick={handleCountryModalClick}
              >
                <div>Country</div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.66732 6.66667L8.00065 10L11.334 6.66667"
                    stroke="#747474"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="ndclist-table__label">
            <div>Country</div>
            <div>Company Name</div>
            <div>Tags</div>
            <div>NDCs-S Value</div>
            <div>Status</div>
          </div>

          {filteredFacilities?.map((facility) => (
            <div className="ndclist-table__item ndclist-table__item-inactive">
              <div className="ndclist-table__item__title">
                {facility?.country}
              </div>
              <div className="ndclist-table__item__subtitle">
                {facility?.companyName}
              </div>
              <div className="ndclist-table__item__tags">
                {facility?.facilityCategory === "green" && (
                  <div className="ndclist-table__item__tags__green">Green</div>
                )}
                {facility?.facilityCategory === "non-green" && (
                  <div className="ndclist-table__item__tags__non-green">
                    Non-green
                  </div>
                )}
              </div>
              <div className="ndclist-table__item__subtitle">
                {facility?.offset}tco2
              </div>
              <div className="ndclist-table__item__status">
                <div className="ndclist-table__item__status__active"></div>
                Active
              </div>
            </div>
          ))}

          {countryModal && (
            <div className="ndclist-modal">
              <div className="ndclist-modal__search">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.18016 12.2002C6.1873 12.2002 5.21673 11.9057 4.3912 11.3541C3.56566 10.8025 2.92224 10.0185 2.54228 9.10123C2.16233 8.18394 2.06292 7.17459 2.25662 6.20081C2.45031 5.22702 2.92842 4.33254 3.63048 3.63048C4.33254 2.92842 5.22702 2.45031 6.20081 2.25662C7.17459 2.06292 8.18394 2.16233 9.10123 2.54228C10.0185 2.92224 10.8025 3.56566 11.3541 4.3912C11.9057 5.21673 12.2002 6.1873 12.2002 7.18016C12.2002 7.83939 12.0703 8.49218 11.818 9.10123C11.5658 9.71028 11.196 10.2637 10.7298 10.7298C10.2637 11.196 9.71028 11.5658 9.10123 11.818C8.49218 12.0703 7.83939 12.2002 7.18016 12.2002ZM7.18016 3.16683C6.38903 3.16683 5.61567 3.40142 4.95788 3.84095C4.30008 4.28047 3.78739 4.90519 3.48464 5.63609C3.18189 6.367 3.10268 7.17126 3.25702 7.94719C3.41136 8.72311 3.79232 9.43584 4.35173 9.99525C4.91114 10.5547 5.62387 10.9356 6.3998 11.09C7.17572 11.2443 7.97999 11.1651 8.71089 10.8623C9.4418 10.5596 10.0665 10.0469 10.506 9.38911C10.9456 8.73131 11.1802 7.95795 11.1802 7.16683C11.1802 6.10596 10.7587 5.08854 10.0086 4.3384C9.25844 3.58825 8.24102 3.16683 7.18016 3.16683Z"
                    fill="#667185"
                  />
                  <path
                    d="M13.3327 13.8336C13.267 13.8339 13.2019 13.8211 13.1412 13.7959C13.0805 13.7708 13.0255 13.7337 12.9793 13.687L10.226 10.9336C10.1377 10.8389 10.0896 10.7135 10.0919 10.584C10.0942 10.4544 10.1466 10.3308 10.2382 10.2392C10.3299 10.1476 10.4534 10.0951 10.583 10.0929C10.7125 10.0906 10.8379 10.1386 10.9327 10.227L13.686 12.9803C13.7796 13.0741 13.8322 13.2011 13.8322 13.3336C13.8322 13.4661 13.7796 13.5932 13.686 13.687C13.6398 13.7337 13.5848 13.7708 13.5241 13.7959C13.4634 13.8211 13.3984 13.8339 13.3327 13.8336Z"
                    fill="#667185"
                  />
                </svg>

                <input
                  type="text"
                  placeholder="Search country"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>

              <div className="ndclist-modal__list">
                {filteredCountries?.map((country) => (
                  <div className="ndclist-modal__list__flex">
                   {selectedCountry !== country?.label && <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
onClick={() => setSelectedCountry(country?.label)}
>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>}


{selectedCountry === country?.label && <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
onClick={() => setSelectedCountry("")}
>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18037)" stroke-width="1.33333"/>
<path d="M5.5 9.49992L7.83333 11.8333L12.5 6.83325" stroke="url(#paint1_linear_2889_18037)" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<linearGradient id="paint0_linear_2889_18037" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
<linearGradient id="paint1_linear_2889_18037" x1="5.5" y1="6.948" x2="12.5203" y2="11.8039" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>}
                    <div>{country?.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {ndcCalendar && (
            <div className="calendar-modal">
              <div className="calendar-modal__flex">
                {`${moment(
                  `${currentYear}-${currentMonth + 1}`,
                  "YYYY-M"
                ).format("MMMM")} ${currentYear}`}

                <div>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="pointer"
                    onClick={handleDecrementMonth}
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="11.5"
                      height="11.5"
                      rx="1.75"
                      fill="white"
                    />
                    <rect
                      x="0.25"
                      y="0.25"
                      width="11.5"
                      height="11.5"
                      rx="1.75"
                      stroke="#E4E7EC"
                      stroke-width="0.5"
                    />
                    <path
                      d="M4.68888 6.18123L7.47538 8.83623C7.52187 8.88055 7.58364 8.90527 7.64788 8.90527C7.71211 8.90527 7.77388 8.88055 7.82038 8.83623L7.82338 8.83323C7.846 8.81174 7.86401 8.78588 7.87631 8.75721C7.88862 8.72854 7.89497 8.69767 7.89497 8.66648C7.89497 8.63528 7.88862 8.60441 7.87631 8.57574C7.86401 8.54708 7.846 8.52121 7.82338 8.49973L5.19938 5.99973L7.82338 3.50073C7.846 3.47924 7.86401 3.45338 7.87631 3.42471C7.88862 3.39604 7.89497 3.36517 7.89497 3.33398C7.89497 3.30278 7.88862 3.27191 7.87631 3.24324C7.86401 3.21458 7.846 3.18871 7.82338 3.16723L7.82038 3.16423C7.77388 3.1199 7.71211 3.09518 7.64788 3.09518C7.58364 3.09518 7.52187 3.1199 7.47538 3.16423L4.68888 5.81923C4.66437 5.84257 4.64486 5.87066 4.63153 5.90177C4.6182 5.93288 4.61133 5.96638 4.61133 6.00023C4.61133 6.03407 4.6182 6.06757 4.63153 6.09868C4.64486 6.1298 4.66437 6.15788 4.68888 6.18123Z"
                      fill="#667185"
                    />
                  </svg>

                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="pointer"
                    onClick={handleIncrementMonth}
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="11.5"
                      height="11.5"
                      rx="1.75"
                      fill="white"
                    />
                    <rect
                      x="0.25"
                      y="0.25"
                      width="11.5"
                      height="11.5"
                      rx="1.75"
                      stroke="#E4E7EC"
                      stroke-width="0.5"
                    />
                    <path
                      d="M7.31112 5.81877L4.52462 3.16377C4.47813 3.11945 4.41636 3.09473 4.35212 3.09473C4.28789 3.09473 4.22612 3.11945 4.17962 3.16377L4.17662 3.16677C4.154 3.18826 4.13599 3.21412 4.12369 3.24279C4.11138 3.27146 4.10503 3.30233 4.10503 3.33352C4.10503 3.36472 4.11138 3.39559 4.12369 3.42426C4.13599 3.45292 4.154 3.47879 4.17662 3.50027L6.80062 6.00027L4.17662 8.49927C4.154 8.52076 4.13599 8.54662 4.12369 8.57529C4.11138 8.60396 4.10503 8.63483 4.10503 8.66602C4.10503 8.69722 4.11138 8.72809 4.12369 8.75676C4.13599 8.78542 4.154 8.81129 4.17662 8.83277L4.17962 8.83577C4.22612 8.8801 4.28789 8.90482 4.35212 8.90482C4.41636 8.90482 4.47813 8.8801 4.52462 8.83577L7.31112 6.18077C7.33563 6.15743 7.35514 6.12934 7.36847 6.09823C7.3818 6.06712 7.38867 6.03362 7.38867 5.99977C7.38867 5.96593 7.3818 5.93243 7.36847 5.90132C7.35514 5.8702 7.33563 5.84212 7.31112 5.81877Z"
                      fill="#667185"
                    />
                  </svg>
                </div>
              </div>
              {renderCalendarGrid()}
              {firstDate && lastDate ? (
                <div className="calendar-modal__button-group">
                  <button onClick={clearDateSelection}>Cancel</button>
                  <button onClick={handleGetNdc}>
                    {rangeLoading ? "Loading..." : "Confirm"}
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
